// extracted by mini-css-extract-plugin
module.exports = {"resultGrid":"ResultGrid_resultGrid__2ycTT","resultGridAside":"ResultGrid_resultGridAside__3Uecv"};